
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.233 14.367l2.078 4.456a.5.5 0 01-.242.665l-1.812.845a.5.5 0 01-.665-.242l-2.125-4.558-2.613 2.613A.5.5 0 018 17.793V5.13a.5.5 0 01.836-.37l9.306 8.46a.5.5 0 01-.298.869l-3.611.278z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    